"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.KansaRefer = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _APIs = require("01_core/constants/APIs");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _stringConsts = require("01_core/constants/stringConsts");
var _openSSO = require("01_core/logics/openSSO");
var _coreConditionActions = require("01_core/reducers/coreConditionActions");
var _coreConfirmActions = require("01_core/reducers/coreConfirmActions");
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _CRadarChart = _interopRequireDefault(require("32_kansa/common/components/materials/CRadarChart"));
var _KansaTgtJigyoBasicInfo = _interopRequireDefault(require("32_kansa/common/components/materials/KansaTgtJigyoBasicInfo"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _CardActions = _interopRequireDefault(require("@mui/material/CardActions"));
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _kansaResultActions = require("../kansaResult/kansaResultActions");
var _ButtonFooter = _interopRequireDefault(require("./components/ButtonFooter"));
var _FollowupList = _interopRequireDefault(require("./components/FollowupList"));
var _KakuninjikoList = _interopRequireDefault(require("./components/KakuninjikoList"));
var _KansaKekkaJissiDate = _interopRequireDefault(require("./components/KansaKekkaJissiDate"));
var _KansaKekkaJissiPlace = _interopRequireDefault(require("./components/KansaKekkaJissiPlace"));
var _KansaKekkaSokatsu = _interopRequireDefault(require("./components/KansaKekkaSokatsu"));
var _ReferReportInfo = _interopRequireDefault(require("./components/ReferReportInfo"));
var _SeijukudoComment = _interopRequireDefault(require("./components/SeijukudoComment"));
var _ShoninDate = _interopRequireDefault(require("./components/ShoninDate"));
var _ShoninshaName = _interopRequireDefault(require("./components/ShoninshaName"));
var _SogoHyoka = _interopRequireDefault(require("./components/SogoHyoka"));
var _kansaResultReferActions = require("./kansaResultReferActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 監査結果参照画面
 */
class KansaRefer extends _react.default.Component {
  constructor(props) {
    super(props);
    /**
     * 前年度ボタン押下時処理
     */
    _defineProperty(this, "onClickOverridePreviousEntries", () => {
      const {
        kansaTgtJigyoBasicInfo
      } = this.props;
      const {
        zennendoSimpleFlg
      } = this.state;
      let dispContent = '';
      if (zennendoSimpleFlg === _CodeConsts.CODE.FLG_VALUE.CODE_0) {
        // 簡易版フラグが0の場合は詳細版
        dispContent = _kansaResultActions.CONTENTS.RESULT_REFER_OLD;
      } else if (zennendoSimpleFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1) {
        // 簡易版フラグが1の場合は簡易版
        dispContent = _kansaResultActions.CONTENTS.RESULT_REFER;
      }
      const params = {
        keyKansaTgtNendo: kansaTgtJigyoBasicInfo.zennendoKansaTgtNendo,
        keyKansaTgtJigyoId: kansaTgtJigyoBasicInfo.zennendoKansaTgtJigyoId,
        keyDispContent: dispContent
      };
      (0, _openSSO.openSubWindowWithParams)('kansa_result', 'kansa_result_refer', '', '', params).focus();
    });
    this.state = {
      zennendoSimpleFlg: '',
      zennendoKansakekkaCreStsCd: '',
      maxPoints: 0
    };
    const {
      loginUserInfo,
      kansaInfo,
      callAPI,
      openInfoBar,
      intl
    } = this.props;
    props.setUserInfo(loginUserInfo);
    const sendData = {
      kansaTgtNendo: kansaInfo.kansaTgtNendo,
      kansaTgtJigyoId: kansaInfo.kansaTgtJigyoId
    };
    this.kansaInfoLocal = sendData;

    // 監査対象基本情報取得
    callAPI(_APIs.KANSA_TGT_JIGYO_BASIC, sendData).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        const kansaTgtJigyoBasicInfo = response.data;
        if (kansaTgtJigyoBasicInfo) {
          props.setkansaTgtJigyoBasicInfo(kansaTgtJigyoBasicInfo);
          // 前年度監査監査結果表示を行う場合、前年度の監査対象基本情報取得し、簡易版フラグを取得する
          if (kansaTgtJigyoBasicInfo.zennendoKansaTgtNendo && kansaTgtJigyoBasicInfo.zennendoKansaTgtJigyoId) {
            const sendDataZennen = {
              kansaTgtNendo: kansaTgtJigyoBasicInfo.zennendoKansaTgtNendo,
              kansaTgtJigyoId: kansaTgtJigyoBasicInfo.zennendoKansaTgtJigyoId
            };
            callAPI(_APIs.KANSA_TGT_JIGYO_BASIC, sendDataZennen).then(responseZennen => {
              if (responseZennen.status === _APIs.STATUS.SUCCESS) {
                const prev = responseZennen.data;
                if (prev) {
                  // 前年度の監査対象基本情報.簡易フラグと監査結果作成状況コードを取得する。
                  this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
                    zennendoSimpleFlg: prev.simpleFlg,
                    zennendoKansakekkaCreStsCd: prev.kansakekkaCreStsCd
                  }));
                } else {
                  // データなしの場合は既定値のまま（空文字）
                  this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
                    zennendoSimpleFlg: '',
                    zennendoKansakekkaCreStsCd: ''
                  }));
                }
              }
            });
          }
        }
      }
    });

    // 前年度フォローアップ取得
    callAPI(_APIs.KANSA_RESULT_KAKUNINJIKO, sendData).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        const followupList = response.data.followupList;
        const goodpointList = response.data.goodpointList;
        const kaizenList = response.data.kaizenList;
        const futekigoList = response.data.futekigoList;
        props.setFollowupList(followupList);
        props.setGoodpointList(goodpointList);
        props.setkaizenList(kaizenList);
        props.setFutekigoList(futekigoList);
        this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
          maxPoints: response.data.maxPoints
        }));
      }
    });

    // 監査結果情報を取得
    callAPI(_APIs.KANSA_RESULT_UPDATE_SEARCH, sendData).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        if (response.data === null) {
          openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.INFO, intl.formatMessage({
            id: _labelConsts.LABEL.CORE_NO_SEARCH_RESULT_MESSAGE
          }));
        } else {
          props.setSeijukudo(response.data.seijukudo);
          props.setEntries(response.data);
        }
      }
    });
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const {
      entries,
      changeBunruiCd,
      changeHakkenjiko,
      kansaTgtJigyoBasicInfo,
      followupList,
      listState,
      goodpointList,
      kaizenList,
      futekigoList,
      seijukudo,
      intl,
      returnBtn,
      closeBtn,
      getCodeName,
      isNewWindow
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
      title: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_RESULT_REFER_TITLE
      }) + (isNewWindow ? _stringConsts.STRING_CONSTS.KAKKO_CIR_START + this.kansaInfoLocal.kansaTgtNendo + intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_NENDO
      }) + _stringConsts.STRING_CONSTS.KAKKO_CIR_END : '')
    }, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 8
      },
      align: "left",
      sx: {
        mb: '10px'
      }
    }, (() => {
      if (!isNewWindow && this.state.zennendoKansakekkaCreStsCd === _CodeConsts.CODE.KANSA_RSLT_STS.CODE_3) {
        return /*#__PURE__*/_react.default.createElement(_CButton.default, {
          autoWidth: true,
          onClick: () => {
            this.onClickOverridePreviousEntries();
          },
          sx: {
            display: 'block',
            m: 0
          }
        }, intl.formatMessage({
          id: _labelConsts.LABEL.KANSA_RESULT_REFER_ZENNENDO_TITLE
        }));
      }
    })()), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 4
      },
      align: "right",
      sx: {
        mb: '10px'
      }
    }, isNewWindow ? closeBtn() : returnBtn(), "\u3000"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 1,
      component: "div"
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_ReferReportInfo.default, {
      reportDate: entries.reportDate,
      reportDestNm: entries.reportDestNm
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_KANSA_BUMON
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_ShoninDate.default, {
      shoninDate: entries.shoninDate
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_ShoninshaName.default, {
      shoninshaNm: entries.shoninshaNm
    })))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_RESULT_GAIYO
      })
    }), /*#__PURE__*/_react.default.createElement(_KansaTgtJigyoBasicInfo.default, {
      data: kansaTgtJigyoBasicInfo && typeof kansaTgtJigyoBasicInfo === 'object' ? kansaTgtJigyoBasicInfo : {}
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_RESULT_KEKKA_SOKATSU
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_SogoHyoka.default, {
      sogohyoka: entries.sogohyoka
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_KansaKekkaJissiDate.default, {
      naibukansaJissiDt: entries.naibukansaJissiDt
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_KansaKekkaJissiPlace.default, {
      naibukansaJissiPlace: entries.naibukansaJissiPlace
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 7
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_KansaKekkaSokatsu.default, {
      sokatsu: entries.sokatsu
    })))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        paddingTop: 8
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_RESULT_ZENNENDO_FOLLOWUP
      })
    })), followupList.length !== 0 ? /*#__PURE__*/_react.default.createElement(_FollowupList.default, {
      followupList: followupList,
      listState: listState,
      changeBunruiCd: changeBunruiCd,
      changeHakkenjiko: changeHakkenjiko
    }) : /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_RESULT_FOLLOWUP_NODATA
      })
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        paddingTop: 8
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_RESULT_HONNENDO_GOODPOINT
      })
    })), goodpointList.length !== 0 ? /*#__PURE__*/_react.default.createElement(_KakuninjikoList.default, {
      list: goodpointList
    }) : /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_RESULT_HONNENDO_NODATA
      }, {
        0: intl.formatMessage({
          id: _labelConsts.LABEL.KANSA_RESULT_HONNENDO_GOODPOINT
        })
      })
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        paddingTop: 8
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_RESULT_HONNENDO_KAIZEN
      })
    })), kaizenList.length !== 0 ? /*#__PURE__*/_react.default.createElement(_KakuninjikoList.default, {
      list: kaizenList
    }) : /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_RESULT_HONNENDO_NODATA
      }, {
        0: intl.formatMessage({
          id: _labelConsts.LABEL.KANSA_RESULT_HONNENDO_KAIZEN
        })
      })
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        paddingTop: 8
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_RESULT_HONNENDO_FUTEKIGO
      })
    })), futekigoList.length !== 0 ? /*#__PURE__*/_react.default.createElement(_KakuninjikoList.default, {
      list: futekigoList
    }) : /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_RESULT_HONNENDO_NODATA
      }, {
        0: intl.formatMessage({
          id: _labelConsts.LABEL.KANSA_RESULT_HONNENDO_FUTEKIGO
        })
      })
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, seijukudo.length !== 0 ? /*#__PURE__*/_react.default.createElement(_CRadarChart.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_SEJUKUDO_HYOKA
      }),
      chartHeight: 450,
      chartWidth: 650,
      domainMax: this.state.maxPoints,
      radarAttr: [{
        name: getCodeName(_CodeConsts.CODE.KANSA_GYOMU_CD.KBN, _CodeConsts.CODE.KANSA_GYOMU_CD.CODE_1),
        key: 'score',
        color: '#FF0000'
      }],
      chartData: seijukudo,
      dataKey: "chosaColumnNm",
      tickCount: this.state.maxPoints + 2
    }) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_SEJUKUDO_HYOKA
      })
    }), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_RESULT_SEIJUKUDO_NODATA
      })
    }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 8
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_SeijukudoComment.default, {
      kansabumonComment: entries.kansabumonComment
    })))), /*#__PURE__*/_react.default.createElement(_CardActions.default, {
      sx: {
        textAlign: 'right'
      },
      disableSpacing: true
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 1.5
    }, /*#__PURE__*/_react.default.createElement(_ButtonFooter.default, {
      returnBtn: returnBtn,
      closeBtn: closeBtn,
      isNewWindow: isNewWindow
    })))));
  }
}
exports.KansaRefer = KansaRefer;
const mapStateToProps = state => {
  return {
    entries: state.kansaResultRefer.entries,
    userInfo: state.kansaResultRefer.userInfo,
    kansaInfo: state.kansaResultRefer.kansaInfo,
    kansaTgtJigyoBasicInfo: state.kansaResultRefer.kansaTgtJigyoBasicInfo,
    followupList: state.kansaResultRefer.followupList,
    goodpointList: state.kansaResultRefer.goodpointList,
    kaizenList: state.kansaResultRefer.kaizenList,
    futekigoList: state.kansaResultRefer.futekigoList,
    seijukudo: state.kansaResultRefer.seijukudo,
    listState: state.kansaResultRefer.listState
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setEntry: key => value => {
      dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](true));
      dispatch(_kansaResultReferActions.kansaResultReferActions[_kansaResultReferActions.TYPES.SET_ENTRY](key, value));
    },
    setEntries: entries => dispatch(_kansaResultReferActions.kansaResultReferActions[_kansaResultReferActions.TYPES.SET_ENTRIES](entries)),
    setkansaTgtJigyoBasicInfo: kansaTgtJigyoBasicInfo => dispatch(_kansaResultReferActions.kansaResultReferActions[_kansaResultReferActions.TYPES.SET_KANSATGTJIGYOBASICINFO](kansaTgtJigyoBasicInfo)),
    setFollowupList: followupList => dispatch(_kansaResultReferActions.kansaResultReferActions[_kansaResultReferActions.TYPES.SET_FOLLOWUPLIST](followupList)),
    setGoodpointList: goodpointList => dispatch(_kansaResultReferActions.kansaResultReferActions[_kansaResultReferActions.TYPES.SET_GOODPOINTLIST](goodpointList)),
    setkaizenList: kaizenList => dispatch(_kansaResultReferActions.kansaResultReferActions[_kansaResultReferActions.TYPES.SET_KAIZENLIST](kaizenList)),
    setFutekigoList: futekigoList => dispatch(_kansaResultReferActions.kansaResultReferActions[_kansaResultReferActions.TYPES.SET_FUTEKIGOLIST](futekigoList)),
    setSeijukudo: seijukudo => dispatch(_kansaResultReferActions.kansaResultReferActions[_kansaResultReferActions.TYPES.SET_SEIJUKUDO](seijukudo)),
    setUserInfo: userInfo => dispatch(_kansaResultReferActions.kansaResultReferActions[_kansaResultReferActions.TYPES.SET_USER_INFO](userInfo)),
    setKansaInfo: kansaInfo => dispatch(_kansaResultReferActions.kansaResultReferActions[_kansaResultReferActions.TYPES.SET_KANSA_INFO](kansaInfo)),
    changeBunruiCd: userId => hakkenjikoBunruiCd => {
      dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](true));
      dispatch(_kansaResultReferActions.kansaResultReferActions[_kansaResultReferActions.TYPES.CHANGE_BUNRUICD](userId, hakkenjikoBunruiCd));
    },
    changeHakkenjiko: userId => hakkenjiko => {
      dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](true));
      dispatch(_kansaResultReferActions.kansaResultReferActions[_kansaResultReferActions.TYPES.CHANGE_HAKKENJIKO](userId, hakkenjiko));
    },
    setContent: content => dispatch(_kansaResultReferActions.kansaResultReferActions[_kansaResultReferActions.TYPES.SET_CONTENT](content)),
    setRegisterDt: dt => {
      dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](false));
      dispatch(_kansaResultReferActions.kansaResultReferActions[_kansaResultReferActions.TYPES.SET_REGISTER_DT](dt));
    },
    overridePreviousEntries: () => {
      dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](true));
    },
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message)),
    openConfirm: (title, message, onClickOk) => dispatch(_coreConfirmActions.coreConfirmActions[_coreConfirmActions.TYPES_CONFIRM.OPEN](title, message, onClickOk))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CodeUtil.withCodeUtil)((0, _CallAPI.withCallAPI)(KansaRefer))));